export default __webpack_public_path__ + "static/media/iconDashboard.43ab41bb.png";